import { TranslationMeta } from '@app/translate/models/translation-meta';
import { environment } from '../environments/environment';

export const REFRESH_VERSION_INTERVAL = 900000;

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 5000;

export const MIDDLEWARE_BASE_URL = '/middleware';
export const API_BASE_URL = `${MIDDLEWARE_BASE_URL}/api`;
export const CUSTOM_ASSETS_URL = `/portal/assets-custom-versioned/${environment.version}`;
export const EVENTS_ENDPOINT = '/portal/events';

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const TIME_REGEX = /^([0-1]?[0-9]|2[0-3])(:([0-5][0-9]))?$/;

export const DEFAULT_CACHE_CLEAR_DELAY = 10 * 1000; // 10 seconds

// Regex that is used to check if the user agent of a registration matches one
// whether the registered ip should not be displayed because it's nonsensical.
export const HIDE_LOCAL_IP_REGEX = /^.*(WebControl|WebMeet|DesktopControl)\/(8|9|10)\..*$/;

export const BaseUrls = {
  EndUser: '/me',
  Enterprise: {
    EndUser: '/enterprise/users/:userId',
    Enterprise: '/enterprise',
  },
  ServiceProvider: {
    EndUser: '/enterprise/:enterpriseId/users/:userId',
    Enterprise: '/enterprise/:enterpriseId',
    ServiceProvider: '/reseller',
  },
};

export const DefaultTranslations: TranslationMeta = {
  defaultLanguage: 'de',
  languages: [
    {
      key: 'de',
    },
    {
      key: 'en',
    },
  ],
};

export const PORTAL_PREFERENCES = 'PORTAL_PREFERENCES';

export function apiUrl(url: string): string {
  return API_BASE_URL + url;
}

export function customAssetsUrl(url: string): string {
  return CUSTOM_ASSETS_URL + url;
}

export function middlewareUrl(url: string): string {
  return MIDDLEWARE_BASE_URL + url;
}
